<template>
    <td v-if="sum.indexOf(field.column) !== -1" :class="{ 'text-center': field.align === 'center' }" >{{ fieldsSum }}</td>
    <td v-else>&nbsp;</td>
</template>

<script>
    export default {
        name: 'ColumnSumCell',
        props: {
            field: { type: Object, required: true },
            items: { type: Array, required: true },
            sum: { type: Array, required: true }
        },
        computed: {
            fieldsSum () {
                return this.items.reduce((total, item) => {
                    if (item !== undefined){
                        const sp = this.field.column.split('.');

                        if (sp.length === 2){
                            return total + item[sp[0]][sp[1]];
                        } else if (sp.length === 1){
                            return total + item[sp[0]];
                        }
                    }
                }, 0);
            }
        }
    }
</script>
